import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface VisitorInfo {
  countryCode: string,
  countryName: string,
  currency: { rate: number } & ICurrency
  dialCode: string,
  timezone: string
}

export interface ICurrency { code: string, name: string, symbol: string }

const initalState: VisitorInfo = {
  countryCode: "",
  countryName: "",
  currency: { code: "", name: "", symbol: "", rate: 0 },
  dialCode: "",
  timezone: ""
};


const visitorInfo = createSlice({
  name: "visitorInfo",
  initialState: initalState,
  reducers: {
    setVisitorInfo: (state, action: PayloadAction<VisitorInfo>) => {
      return action.payload
    }
  },
})

export const { setVisitorInfo } = visitorInfo.actions;
export default visitorInfo.reducer